import { Input, type InputProps } from '@//components/Input';
import { InputDescription } from '@//components/InputDescription';
import { InputLabel } from '@//components/InputLabel';
import { InputStateMessage } from '@//components/InputStateMessage';
import styles from './Textfield.module.scss';

export interface TextfieldProps extends InputProps {
  id: string;
  label: string;
  description?: string;
  stateMessage?: string;
  testId?: string;
}

export const Textfield = ({
  id,
  label,
  description,
  stateMessage,
  placeholder,
  ariaLabel = label,
  unit,
  unitPosition,
  state,
  disabled,
  testId,
  ...props
}: TextfieldProps) => (
  <div className={styles.textfield}>
    <InputLabel htmlFor={id} data-testid={testId ? `${testId}-label` : undefined}>
      {label}
    </InputLabel>
    <Input
      id={id}
      testId={testId ? `${testId}-input` : undefined}
      ariaLabel={ariaLabel}
      placeholder={placeholder}
      disabled={disabled}
      unit={unit}
      unitPosition={unitPosition}
      state={state}
      ariaDescribedby={
        [stateMessage ? `${id}-state-message` : null, description ? `${id}-description` : null]
          .filter(Boolean)
          .join(',') || undefined
      }
      {...props}
    />
    {description && (
      <InputDescription
        id={`${id}-description`}
        data-testid={testId ? `${testId}-description` : undefined}
      >
        {description}
      </InputDescription>
    )}
    {stateMessage && state && (
      <InputStateMessage
        id={`${id}-state-message`}
        state={state}
        data-testid={testId ? `${testId}-state-message` : undefined}
      >
        {stateMessage}
      </InputStateMessage>
    )}
  </div>
);
